import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomerLayout } from '../../components/layouts/CustomerLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Star, Check, ShieldCheck } from 'lucide-react';
import { toPersianDigits, formatCurrency } from '../../utils/persian';
const companies = [{
  id: 1,
  name: 'بیمه ایران',
  price: 4500000,
  rating: 4.5,
  satisfaction: '۹۸٪',
  branches: 'سراسر کشور',
  features: ['پرداخت خسارت سیار', 'پاسخگویی ۲۴ ساعته'],
  bestValue: false
}, {
  id: 2,
  name: 'بیمه پاسارگاد',
  price: 4200000,
  rating: 4.8,
  satisfaction: '۹۵٪',
  branches: 'مراکز استان‌ها',
  features: ['پرداخت آنلاین خسارت', 'تخفیف خرید نقدی'],
  bestValue: true
}, {
  id: 3,
  name: 'بیمه دانا',
  price: 4350000,
  rating: 4.2,
  satisfaction: '۹۰٪',
  branches: 'اکثر شهرها',
  features: ['اقساط بدون چک', 'هدیه بیمه آتش‌سوزی'],
  bestValue: false
}];
export function ComparisonPage() {
  const navigate = useNavigate();
  return <CustomerLayout data-id="element-326">
      <div className="space-y-6" data-id="element-327">
        <div className="text-center mb-8" data-id="element-328">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-329">مقایسه و خرید</h1>
          <p className="text-gray-500 mt-2" data-id="element-330">
            بهترین بیمه را متناسب با شرایط خود انتخاب کنید
          </p>
        </div>

        <div className="grid gap-4" data-id="element-331">
          {companies.map(company => <Card key={company.id} className={`transition-all hover:shadow-lg ${company.bestValue ? 'border-2 border-primary ring-4 ring-primary/10' : ''}`} data-id="element-332">
              <CardContent data-id="element-333">
                <div className="flex flex-col lg:flex-row items-center gap-6" data-id="element-334">
                  {/* Company Info */}
                  <div className="flex-1 text-center lg:text-right w-full" data-id="element-335">
                    <div className="flex items-center justify-center lg:justify-start gap-3 mb-2" data-id="element-336">
                      <h3 className="text-xl font-bold text-gray-900" data-id="element-337">
                        {company.name}
                      </h3>
                      {company.bestValue && <Badge className="bg-primary text-white" data-id="element-338">
                          پیشنهاد ویژه
                        </Badge>}
                    </div>
                    <div className="flex items-center justify-center lg:justify-start gap-4 text-sm text-gray-600" data-id="element-339">
                      <div className="flex items-center gap-1" data-id="element-340">
                        <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" data-id="element-341" />
                        <span data-id="element-342">{toPersianDigits(company.rating)}</span>
                      </div>
                      <span className="w-1 h-1 bg-gray-300 rounded-full" data-id="element-343"></span>
                      <span data-id="element-344">
                        رضایت: {toPersianDigits(company.satisfaction)}
                      </span>
                      <span className="w-1 h-1 bg-gray-300 rounded-full" data-id="element-345"></span>
                      <span data-id="element-346">شعب: {company.branches}</span>
                    </div>
                  </div>

                  {/* Features */}
                  <div className="flex-1 w-full border-t lg:border-t-0 lg:border-r py-4 lg:py-0 lg:pr-6" data-id="element-347">
                    <ul className="space-y-2" data-id="element-348">
                      {company.features.map((feature, idx) => <li key={idx} className="flex items-center gap-2 text-sm text-gray-600" data-id="element-349">
                          <Check className="h-4 w-4 text-green-500" data-id="element-350" />
                          {feature}
                        </li>)}
                      <li className="flex items-center gap-2 text-sm text-gray-600" data-id="element-351">
                        <ShieldCheck className="h-4 w-4 text-blue-500" data-id="element-352" />
                        سقف تعهد مالی: {toPersianDigits('400')} میلیون
                      </li>
                    </ul>
                  </div>

                  {/* Price & Action */}
                  <div className="flex-1 w-full lg:w-auto flex flex-col items-center lg:items-end gap-4 border-t lg:border-t-0 lg:border-r py-4 lg:py-0 lg:pr-6" data-id="element-353">
                    <div className="text-center lg:text-left" data-id="element-354">
                      <p className="text-sm text-gray-500 mb-1" data-id="element-355">قیمت نهایی</p>
                      <p className="text-2xl font-bold text-primary" data-id="element-356">
                        {formatCurrency(company.price)}
                      </p>
                    </div>
                    <Button className="w-full lg:w-auto min-w-[140px]" onClick={() => navigate('/checkout')} data-id="element-357">
                      انتخاب و خرید
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </CustomerLayout>;
}